<template>

<div id="searchandresults">
    
    <div class="searchbox">
      <div class="searchboxInner">
        <input v-model="searchQuery"  v-on:keyup="onChange" id="searchQuery" type="text">
        <button class="searchbutton" v-if="searchQuery != '' " v-on:click="resetSearch">Suchen</button>
      </div>
    </div>
    
    <div class="autocomplete-results" v-if="isOpen && results.length > 0 ">
      <div class="result-list">
       <div class="autocomplete-result" v-for="(result, i) in results" :key="i" v-on:click="setResult(result)">
           {{result.articlenumber}}
        </div>
      </div>
    </div>
    
</div> 
</template>
<script>
  export default {
    name: 'Search',
    props: {
      items: {
        type: Array,
        required: false,
        default: () => [],
      },
      isAsync: {
        type: Boolean,
        required: false,
        default: false,
      },
    },    
    data: function(){
      return {
         searchQuery: '',
         results: [],
         isOpen: false,
         isLoading: false,
         arrowCounter: -1,
         show: 1,
      }
    },
    methods:{
      resetSearch: function(){
        this.searchQuery = ""
        this.filterResults()
        this.isOpen = false;        
      },

      submitSearch: function(){
        //alert('search ' + this.searchQuery);
      },
    
    
      onChange(e) {

        if (e.keyCode == 40 ) { this.onArrowDown(e); return; }
        if (e.keyCode == 38 ) { this.onArrowUp(e); return; }

        // Let's warn the parent that a change was made
        this.$emit('input', this.searchQuery );

        // Is the data given by an outside ajax request?
        if (this.isAsync) {
          this.isLoading = true;
        } else {
          // Let's  our flat array
          this.filterResults();
          this.isOpen = true;
        }
      },

      filterResults() {
      
          this.results = this.items.filter((item) => {
            return (
              (item.articlenumber && item.articlenumber.indexOf(this.searchQuery) > -1 )
              )
          });

      },
      setResult(result) {
        this.searchQuery = ""; //result.bez1;
        this.isOpen = false;
        this.$router.push({ name: 'ProductPage', params: { articlenumber: result.articlenumber }})
        
        //console.log('change route')
      },
      onArrowDown(evt) {
        //console.log('arrowDown');
        if (this.arrowCounter < this.results.length) {
          console.log('arrowDown')
          this.arrowCounter = this.arrowCounter + 1;
        }
      },
      onArrowUp() {
        if (this.arrowCounter > 0) {
          console.log('arrowUp')
          this.arrowCounter = this.arrowCounter -1;
        }
      },
      onEnter() {
        this.searchQuery = this.results[this.arrowCounter];
        this.isOpen = false;
        this.arrowCounter = -1;
      },
      handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
          this.isOpen = false;
          this.arrowCounter = -1;
        }
      }


    },
    watch: {
      items: function (val, oldValue) {
        // actually compare them
        if (val.length !== oldValue.length) {
          this.results = val;
          this.isLoading = false;
        }
      },
    },
    mounted: function(){
      document.getElementById("searchQuery").focus();
      document.addEventListener('click', this.handleClickOutside)
      //console.log( this.items );
      //this.results = this.items
    },
    destroyed() {
      document.removeEventListener('click', this.handleClickOutside)
    }
  }
</script>
<style>

/*   #searchandresults { display: none;  } */
  
  #searchandresults { padding: 0 0 0 0; flex: 1 1 100%; position: absolute; max-width: 40em; padding: 0 0.933333em;}
  #searchandresults .block { padding: 0.43333em 0; margin: 0; display: block; }
  #searchandresults .searchbox { padding: 0;  background: transparent;  }


@media screen and (min-width: 768px) {
  #searchandresults { display: block; }
  #searchandresults { padding: 0 0 0 0; flex: 1 1 100%; position: relative; max-width: 40em; padding: 0 0.933333em;}  
  #searchandresults .searchbox { display: flex; align-items: center; justify-content: center; }
}



  #searchandresults .searchboxInner { width: 100%; position: relative; margin: 0 0 0 0; display: flex; }
  
  #searchandresults #searchQuery { margin: 0; padding: 0 0.93333em 0.4333em 0 !important; width: 100%; 
    background: transparent url(/img/icons-green/search.svg) 0.73333em center no-repeat; background-size: 1.6333333em;
    border:0; border-bottom: 1px solid  #fff;; outline: 0; border-radius: 0; text-align: left; color: #fff;
  }
  #searchandresults #searchQuery:focus { border-color: #fff; }
  
  
  
  #searchandresults p.aligncenter { text-align: center; }
  
  #searchandresults .searchbutton { border: 0; padding: 0; margin: 0; background: transparent url(/img/icons-red/close.svg) center center no-repeat; 
    background-size: 1.6333333em; text-indent: -99999px; height: 1.4333333em; line-height: 1.43333333em; width: 1.43333333em; outline: none;
    position: absolute; right: 0; top: -0.1933em; transition: background-color 0.3s ease-out; border-radius: 3px; }
  #searchandresults .searchbutton:hover, .searchbutton:focus { background-color: rgba(0,0,0,0.5); }  


  #searchandresults .autocomplete-results { 
      height: auto; max-height: 80vh; width: 86.5555vw; margin: 0 auto; position: absolute; top: 3.173em; left: -0.93333em; right: 0.933333em; 
      border: 1px solid rgba(0,0,0,0.1); border-radius: 2px; background: rgba(0,0,0,0.7) ; padding: 1em 0;
      }
  #searchandresults .autocomplete-results:before { 
    content: " "; border: 8px solid rgba(0,0,0,0.7) ; border-top: 0; border-left-color: transparent; 
    border-right-color: transparent; position: absolute; top: -9px; left: 2.8333333em; 
    }

  @media screen and (min-width: 768px) {
    #searchandresults .autocomplete-results { width: auto; left: -0.5333rem; right: 0;  }
    #searchandresults .autocomplete-results:before { left: 1.1333333em; } 
    }

  #searchandresults .result-list { overflow: auto; -webkit-overflow-scrolling: touch; max-height: 74vh; }
  #searchandresults .autocomplete-result { padding: 0.6333333em 0; margin: 0 0.9333333em; border-top: 1px solid #ddd; text-align: left; }
  #searchandresults .autocomplete-result:first-child { border-top: 0; }
  
  #searchandresults .icon { display: inline-block; width: 2.1333333em; height: 2.133333333em; line-height: 2.133333333em; padding: 0; margin: 0; border: 0; text-indent: -9999px; }  
  #searchandresults .icon:hover { background-color: rgba(0,0,0,0.5); }
  #searchandresults .icon-chevron-right { background: url(/img/icons-red/chevron-right.svg) center center no-repeat; background-size: 2.133333333em; }
  #searchandresults .icon-chevron-right:hover { background: url(/img/icons-red/chevron-right.svg) center center no-repeat; background-size: 2.133333333em; }



</style>
